import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const CustomerContext = createContext(null);

export function CustomerProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/customer-auth/me")
      .then((r) => setCustomer(r.data))
      .catch(() => setCustomer(null))
      .finally(() => setLoading(false));
  }, []);

  const register = async (name, email, password) => {
    const { data } = await api.post("/customer-auth/register", {
      name, email, password, origin_url: window.location.origin,
    });
    localStorage.setItem("td_customer_token", data.token);
    setCustomer(data.customer);
    return data.customer;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/customer-auth/login", { email, password });
    localStorage.setItem("td_customer_token", data.token);
    setCustomer(data.customer);
    return data.customer;
  };

  const logout = async () => {
    try { await api.post("/customer-auth/logout"); } catch {}
    localStorage.removeItem("td_customer_token");
    setCustomer(null);
  };

  return (
    <CustomerContext.Provider value={{ customer, loading, register, login, logout }}>
      {children}
    </CustomerContext.Provider>
  );
}

export const useCustomer = () => useContext(CustomerContext);
